

import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import apiService from "../api/ApiService";
import { Close } from '@mui/icons-material';
const moment=require('moment-jalaali');


const DeleteCattle=()=>{
    const {currentCattle}=useSelector(state=>state.cattle)
   
    const {openDeleteModal,closedeleteModal,isDeleteModalOpen}=useGlobalContext();
   
    
    const navigate=useNavigate()
    
    
    const deleteCattle=async()=>{           
                
                const res=await apiService.deleteCattle(currentCattle.id);
                
                openDeleteModal();navigate('/ListDam')
                
    }
    

    return <div onClick={closedeleteModal} className={`modal-overlay ${isDeleteModalOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
                <PriorityHighIcon fontSize='large'/>
            <h4 >آیا از حذف این دام مطمئن هستید؟</h4>
            </div>
       
        
        <button className="EditMOdalBtnForm" onClick={deleteCattle}>
            تایید
        </button>
        
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default DeleteCattle